const woocommerceCheckout = () => {
    $('body').on('click', '#place_order', () => {
        if ($('.pickup-location-lookup').val() === '') {
            $('.select2-selection').addClass('border-warning');
        }
        if ($('#wc-local-pickup-plus-datepicker-0').val() === '') {
            $('#wc-local-pickup-plus-datepicker-0').addClass('border-warning');
        }
    });

    $('form.checkout').on('change', 'input.qty', () => {
        const data = {
            action: 'update_order_review',
            security: wc_checkout_params.update_order_review_nonce,
            post_data: $('form.checkout').serialize()
        };

        jQuery.post(ajaxUrl, data, () => {
            $('body').trigger('update_checkout');
        });
    });

    $("#order_comments").on( "focusout",function(){
        if ($('#order_comments').val() !== '') {
            document.getElementById('MC_CustomerOrderNote').value = $('#order_comments').val();
        }
    });

    $("body").on('click', '.pickup', () => {
        $('#place_order').show();
    });

    $('body').bind('DOMSubtreeModified', () => {
        // $('.woocommerce-checkout-review-order-table .select2').removeClass('select2-container--default');
        // $('.woocommerce-checkout-review-order-table .select2').css('pointer-events', 'none');
    });

    $('body').on('removed_from_cart', () => {
        $(document.body).trigger('update_checkout');
    });

    $('body').on('update_checkout', () => {
        $(document.body).trigger('wc_fragment_refresh');
    });
};

export default woocommerceCheckout;
